var map = {
	"./en_GB.json": [
		"../../../../../src/assets/i18n/en_GB.json",
		"en_GB.json"
	],
	"./pl_PL.json": [
		"../../../../../src/assets/i18n/pl_PL.json",
		"pl_PL.json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /dist/src/assets/i18n lazy ^\.\/.*\.json$
// module id = ../../../../../src/assets/i18n lazy recursive ^\.\/.*\.json$
// module chunks = main